import { useEffect } from "react";
import "./Banner.scss";
import scrollbutton from "../../assets/images/scrollbutton.png";
import scrollbuttondesktop from "../../assets/images/scrollbuttondesktop.png";
import arrowsgroup from "../../assets/images/arrowsgroup.svg";
const Banner = () => {
  useEffect(() => {
    const parallax = document.getElementsByClassName("banner")[0];

    window.addEventListener("scroll", function () {
      let offset = window.pageYOffset;
      parallax.style.backgroundPositionY = offset * 0.7 + "px";
    });
  }, []);
  return (
    <div className="banner">
      <img alt="arrows-group" src={arrowsgroup} className="arrows-group" />
      <div className="container">
        <div className="title">
          Lagos Climate Adaptation &amp; <span>Resilience Plan</span>
        </div>
        <div className="scroll-button mobile">
          <img src={scrollbutton} alt="scroll" className="mobile" />
        </div>
      </div>
      <div className="scroll-button desktop">
        <img src={scrollbuttondesktop} alt="scroll" className="desktop" />
      </div>
    </div>
  );
};

export default Banner;
